import { gql } from "@apollo/client";

export const GET_SESSION_NOTES = gql(/* GraphQL */`
  query SessionNotes($sessionId: UUID!) {
    session(id: $sessionId) {
      __typename
      id
      student {
        __typename
        id
        firstName
        lastName
      }
      notes {
        id
        type
        body
        createdAt
        person {
          id
          firstName
          lastName
          role {
            normalizedName
          }
        }
      }
    }
  }
`);
